import Axios from '@/http'

export default {
  // 任务统计
  taskCountApi(params) {
    return new Promise((resolve, reject) => {
      Axios.post('dataHomePage/taskCount', params).then((res) => {
        return resolve(res)
      })
    })
  },

  // 考勤状态
  dailyCheckCountApi(params) {
    return new Promise((resolve, reject) => {
      Axios.post('dataHomePage/dailyCheckCount', params).then((res) => {
        return resolve(res)
      })
    })
  },

  // 报警数量
  warningRecordCountApi(params) {
    return new Promise((resolve, reject) => {
      Axios.post('dataHomePage/warningRecordCount', params).then((res) => {
        return resolve(res)
      })
    })
  },

  // 图像采集
  recognitionCountApi() {
    return new Promise((resolve, reject) => {
      Axios.post('dataHomePage/recognitionCount').then((res) => {
        return resolve(res)
      })
    })
  },

  // 基础建设
  infrastructureCountApi() {
    return new Promise((resolve, reject) => {
      Axios.post('dataHomePage/infrastructureCount').then((res) => {
        return resolve(res)
      })
    })
  },

  // 文件数量
  mediaFileCountApi() {
    return new Promise((resolve, reject) => {
      Axios.post('dataHomePage/mediaFileCount').then((res) => {
        return resolve(res)
      })
    })
  },

  // 报警数量 按周统计
  warningRecordWeekCountApi(params) {
    return new Promise((resolve, reject) => {
      Axios.post('dataHomePage/warningRecordWeekCount', params).then((res) => {
        return resolve(res)
      })
    })
  },

  // 考勤汇总
  dailyCheckStatusCountApi(params) {
    return new Promise((resolve, reject) => {
      Axios.post('dataHomePage/dailyCheckWorkStatusCount', params).then(
        (res) => {
          return resolve(res)
        }
      )
    })
  },

  // 设备统计（使用时长、本月报警、今日考勤）
  getDeviceDatacalApi(params) {
    return new Promise((resolve, reject) => {
      Axios.post('dataHomePage/deviceDataCal', params).then((res) => {
        return resolve(res)
      })
    })
  },

  // 设备汇总
  deviceTypeCountApi(params) {
    return new Promise((resolve, reject) => {
      Axios.post('dataHomePage/deviceTypeCount', params).then((res) => {
        return resolve(res)
      })
    })
  },

  // 报警汇总
  warningTypeCountApi(params) {
    return new Promise((resolve, reject) => {
      Axios.post('dataHomePage/warningTypeCount', params).then((res) => {
        return resolve(res)
      })
    })
  }
}
